import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
import { ReportCampaignConst } from './report.const';
import { Observable } from 'rxjs';
import { FieldService } from 'app/common/services/Field.service';
import { CommonSettingsService } from '../../../../../common/share-data/common.setting.service';
import { CommonService } from '../../../../../common/services/Common.service';

declare var require: any;
const moment = require('moment');
const HighchartsExporting = require('highcharts/modules/exporting');
declare var $: any;
@Component({
  selector: 'report-campaign',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css'],
  providers: [ReportService, ExportCustomService, FieldService],
})
export class ReportComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Input() Type: any;
  @Input() goBack: any;
  @Input() campaignId: string;
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public dataAgentTop: any = null;
  public dataAgentAct: any = null;
  public modelFilter: any = {
    optionAgentTop: 'total_call' as 'total_call' | 'success_call',
    from_date: moment().subtract(7, 'days').startOf('day').toDate(), // Change to .toDate()
    to_date: moment().endOf('day').toDate(), // Change to .toDate()
  };

  public ticketFields: any[] = [];
  public fieldSelected: any[] = [];
  public isLoading: any = false;

  public displayColumns: any[] = [];
  public dataSummaryChart: any = null;
  public optionSummaryChart: any = null;

  public pageSize: number = 10;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalItems: number = 0;

  public dataOptionAgentTop: any = [
    { label: 'Chuyên viên nhiều cuộc gọi nhất', value: 'total_call' },
    {
      label: 'Chuyên viên nhiều cuộc gọi thành công nhất',
      value: 'success_call',
    },
  ];
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private fieldService: FieldService,
    private sharedCommonSettings: CommonSettingsService,
    private commonService: CommonService
  ) {
    super(changeDetector, toastr, modalService);
  }
  chartOptions: Highcharts.Options;

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    HighchartsExporting(Highcharts);
    this.displayColumns = ReportCampaignConst.displayColumns();
    await this.loadTicketFields();
    await this.loadDataCampaignAgent();
    await this.loadDataCampaignSummary();
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      if (e.type === 'select') {
        this.ticketFields.push({
          key: e.key,
          title: e.title,
          display: false,
          data: e.data,
        });
      }
    });
  }

  loadDataCampaignAgent() {
    this.isLoading = true;
    // Get the first and last day of the current mont
    let payloadCampaignAgent = {
      show_rank: true,
      show_time_calling: true,
      rank_sort: this.modelFilter.optionAgentTop,
      offset: (this.currentPage - 1) * this.pageSize,
      limit: this.pageSize,
    };

    if (this.campaignId) {
      payloadCampaignAgent['campaign_id'] = this.campaignId;
    } else {
      (payloadCampaignAgent['date_to'] = moment(this.modelFilter.to_date).format('YYYY-MM-DD')),
        (payloadCampaignAgent['date_from'] = moment(this.modelFilter.from_date).add(1, 'day').format('YYYY-MM-DD'));
    }

    this.reportService.summaryCampaignAgent(payloadCampaignAgent).subscribe(
      res => {
        let total = 0;
        this.totalItems = res.data.total;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        this.dataAgentTop = res.data.rank
          .map(value => {
            value.count = value[this.modelFilter.optionAgentTop];
            total += value.count;
            return value;
          })
          .filter(value => value.count > 0);

        this.dataAgentTop = this.dataAgentTop.map((value, index) => {
          value.percent = (value.count / this.dataAgentTop[0].count) * 100;
          return value;
        });
        if (this.dataAgentTop.length === 0) {
          this.dataAgentTop = null;
        }

        this.dataAgentAct = res.data.list.map((value, index) => {
          value['STT'] = index + 1;
          return value;
        });
        this.isLoading = false;
      },

      error => {
        console.error('Error fetching summary data:', error);
        this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu tổng hợp', 'Lỗi');
      }
    );
  }

  async loadDataCampaignSummary() {
    this.isLoading = true;
    const payloadCampaignSummary = {} as any;
    // @ts-ignore
    const { campaign_report_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    if (campaign_report_columns) {
      this.fieldSelected = JSON.parse(campaign_report_columns);
    } else {
      this.fieldSelected = [];
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          campaign_report_columns: JSON.stringify(this.fieldSelected),
        })
        .toPromise();
    }
    this.ticketFields = this.ticketFields.map(field => {
      if (this.fieldSelected.includes(field.key)) {
        field.display = true;
      }
      return field;
    });
    if (this.fieldSelected.length > 0) {
      payloadCampaignSummary.fields = this.fieldSelected;
    }
    if (this.campaignId) {
      payloadCampaignSummary['campaign_id'] = this.campaignId;
    } else {
      (payloadCampaignSummary['date_to'] = moment(this.modelFilter.to_date).format('YYYY-MM-DD')),
        (payloadCampaignSummary['date_from'] = moment(this.modelFilter.from_date).add(1, 'day').format('YYYY-MM-DD'));
    }
    this.reportService.summaryCampaignSummary(payloadCampaignSummary).subscribe(
      res => {
        this.dataSummaryChart = res.data;
        this.generateDataSummaryTitle();
        this.isLoading = false;
      },

      error => {
        console.error('Error fetching summary data:', error);
        this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu tổng hợp', 'Lỗi');
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  ngAfterViewInit(): void {}
  onOptionAgentTopChange() {
    this.loadDataCampaignAgent();
  }

  async onFieldChange(field) {
    const c = this.fieldSelected.find(value => value === field.key);
    if (c) {
      this.fieldSelected = this.fieldSelected.filter(value => value !== field.key);
    } else {
      this.fieldSelected.push(field.key);
    }
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        campaign_report_columns: JSON.stringify(this.fieldSelected),
      })
      .toPromise();
    await this.loadDataCampaignSummary();
  }

  generateDataSummaryTitle() {
    if (!this.dataSummaryChart) {
      return { categories: [], datas: [], maxValue: 0 };
    }
    let datas = [];
    let total = 0;
    Object.keys(this.dataSummaryChart).map(key => {
      if (key !== 'total_call') {
        total += this.dataSummaryChart[key];
      }
      let title = '';
      switch (key) {
        case 'total_call':
          title = 'Tổng số cuộc gọi';
          datas.push({
            key: 'total_call',
            value: this.dataSummaryChart[key],
            title,
          });
          break;
        case 'success_call':
          title = 'Tổng số cuộc gọi thành công';
          datas.push({
            key: 'success_call',
            value: this.dataSummaryChart[key],
            title,
          });
          break;
        case 'not_answer_call':
          title = 'Tổng số cuộc gọi không được kết nối';
          datas.push({
            key: 'not_answer_call',
            value: this.dataSummaryChart[key],
            title,
          });
          break;
        case 'error_call':
          title = 'Tổng số cuộc gọi có lỗi';
          datas.push({
            key: 'error_call',
            value: this.dataSummaryChart[key],
            title,
          });
          break;
        default:
          const keys = key.slice(0, -1);
          const fields = this.ticketFields.find(a => a.key === keys);
          const check = datas.find(a => a.key === keys);
          if (fields && !check) {
            fields.data.map((e, i) => {
              datas.push({
                key: keys,
                value: this.dataSummaryChart[keys + i],
                title: fields.title + ' ' + e,
              });
            });
          }
          break;
      }
    });

    this.optionSummaryChart = datas.map(e => {
      if (total > 0) {
        e.percent = Number(Number((e.value / total) * 100).toFixed(1));
      }
      if (e.key === 'total_call') {
        e.percent = 100;
      }
      return e;
    });
  }

  onDateChange(key, value) {
    this.loadDataCampaignAgent();
    this.loadDataCampaignSummary();
    // this.modelFilter[key] = value
    // this.loadData()
  }

  onPageChange(page) {
    this.currentPage = page;
    this.loadDataCampaignAgent();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/report/report.component.ts